export const NODE_NAME = 'list_item';
